import { Injectable, inject } from '@angular/core';
import { NetzbetreiberTeilgebieteInfo } from '../../auth/netzbetreiber-teilgebiete-info';
import { AuthenticationService } from '../../auth/authentication.service';
import { StorageService } from '../storage/storage.service';

@Injectable({
    providedIn: 'root',
})
export class TeilgebietSelectionService {
    private authService = inject(AuthenticationService);
    private storageService = inject(StorageService);

    private selectedStwId: string | undefined;

    public getAvailableTeilgebiete(): NetzbetreiberTeilgebieteInfo[] | undefined {
        return this.authService.user?.teilgebieteInfos;
    }

    public hasMultipleTeilgebiete(): boolean {
        const teilgebiete = this.getAvailableTeilgebiete();
        return teilgebiete != null && teilgebiete.length > 1;
    }

    public getSelectedTeilgebiet(): NetzbetreiberTeilgebieteInfo | undefined {
        const stwId = this.getSelectedStadtwerkeId();
        return this.getAvailableTeilgebiete()?.find(value => value.stadtwerkeId === stwId);
    }

    public getSelectedStadtwerkeId(): string | undefined {
        if (this.selectedStwId == null) {
            this.selectedStwId = this.storageService.getPreselectedTeilgebietStwId();
        }
        if (this.selectedStwId == null) {
            this.selectedStwId = this.getAvailableTeilgebiete()?.[0]?.stadtwerkeId;
        }
        return this.selectedStwId;
    }

    public setSelectedTeilgebiet(teilgebieteInfo: NetzbetreiberTeilgebieteInfo) {
        this.setSelectedTeilgebietViaStadtwerkeId(teilgebieteInfo.stadtwerkeId);
    }

    public setSelectedTeilgebietViaStadtwerkeId(stadtwerkeId: string) {
        this.selectedStwId = stadtwerkeId;
        this.storageService.setPreselectedTeilgebietStwId(stadtwerkeId);
    }

    public resetSelection() {
        this.storageService.deletePreselectedTeilgebietStwId();
        this.selectedStwId = undefined;
    }
}
